module.exports = __webpack_public_path__ + "img/pv-v2.cf3cfc75.svg";